import { render } from "./LoginInstall.vue?vue&type=template&id=2295a792&scoped=true"
import script from "./LoginInstall.vue?vue&type=script&lang=js"
export * from "./LoginInstall.vue?vue&type=script&lang=js"

import "./LoginInstall.vue?vue&type=style&index=0&id=2295a792&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2295a792"]])

export default __exports__